import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { VehicleOptions } from "../../types/Vehicles";

export const getQuoteOptions = (
  quoteId: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["quote-options", quoteId],
    queryFn: (): Promise<VehicleOptions> => {
      return fetchWithAuth<VehicleOptions>("getQuoteOptions", quoteId);
    },
    enabled: isQueryEnabled(options),
  });
};
